import * as yup from "yup";

export const SeguroAmbientalSchema = yup.object().shape({
  aseguradora: yup
    .string()
    .max(100, "errors.seguroAmbiental.aseguradora.max")
    .required("errors.seguroAmbiental.aseguradora.required")
    .default(""),
  poliza: yup
    .string()
    .max(20, "errors.seguroAmbiental.poliza.max")
    .required("errors.seguroAmbiental.poliza.required")
    .default(""),
  vencimiento: yup
    .string()
    .typeError("errors.seguroAmbiental.vencimiento.type")
    .test(
      "vencimiento.min",
      "errors.seguroAmbiental.vencimiento.min",
      (value, context) => {
        if (!value) return true;
        const dateValue = new Date(value);
        return dateValue > new Date();
      },
    )
    .required("errors.seguroAmbiental.vencimiento.required")
    .default(null),
  importe: yup
    .number()
    .positive("errors.seguroAmbiental.importe.min")
    .required("errors.seguroAmbiental.importe.required")
    .default(0),
});
